import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-realsize-image-modal',
  templateUrl: './realsize-image-modal.component.html',
  styleUrls: ['./realsize-image-modal.component.scss']
})
export class RealsizeImageModalComponent implements OnInit {

  @Output()
  private modalStateChanged: EventEmitter<boolean> = new EventEmitter();

  @Input()
  public image: string;
  @Input()
  public images: string[];
  @Input()
  public extensions: string[];
  @Input()
  public index: number;


  constructor() { }

  ngOnInit() {
    $(document).ready(function () {

      var picture = $('#sample_picture');

      picture.guillotine({width: 1400, height: 2000});
      picture.one('load', function(){
       picture.guillotine({eventOnChange: 'guillotinechange'});

       /* var data = picture.guillotine('getData');
        for(var key in data) { $('#'+key).html(data[key]); }*/

        picture.guillotine('fit');

        $('#rotate_left').click(function(){ picture.guillotine('rotateLeft'); });
        $('#rotate_right').click(function(){ picture.guillotine('rotateRight'); });
        $('#fit').click(function(){ picture.guillotine('fit'); });
        $('#zoom_in').click(function(){ picture.guillotine('zoomIn'); });
        $('#zoom_out').click(function(){ picture.guillotine('zoomOut'); });

        // Update data on change
        /*picture.on('guillotinechange', function(ev, data, action) {
          data.scale = parseFloat(data.scale.toFixed(4));
          for(var k in data) { $('#'+k).html(data[k]); }
        });*/
      });

      if (picture.prop('complete')) picture.trigger('load')


    });

  }

  scroll(direction: string) {
    if (direction === 'left') {
      this.index--;
    }
    else if (direction === 'right'){
      this.index++;
    }
  }


  closeModal() {
    this.modalStateChanged.emit(false);
  }

}
